/**
 * Raw colour scales — docs/04-design-system.md §2.1.
 * These are the ONLY hex values in the repository.
 * Components must never reference a primitive directly; use the semantic
 * tokens in `colors.ts` instead.
 */
export const primitives = {
  green: {
    50: '#E9F4EE',
    100: '#C7E5D4',
    200: '#9CD1B4',
    300: '#6BBB92',
    400: '#3FA574',
    500: '#1E8C5C',
    600: '#14724A',
    700: '#0B5A39',
    800: '#064228',
    900: '#032B1A',
  },
  gold: {
    50: '#FDF6E3',
    100: '#F9E7B0',
    200: '#F2D579',
    300: '#E8BF44',
    400: '#D9A81C',
    500: '#B98A0F',
    600: '#946D0B',
    700: '#6F5108',
    800: '#4B3705',
    900: '#2C2003',
  },
  slate: {
    50: '#F8FAFC',
    100: '#F1F5F9',
    200: '#E2E8F0',
    300: '#CBD5E1',
    400: '#94A3B8',
    500: '#64748B',
    600: '#475569',
    700: '#334155',
    800: '#1E293B',
    900: '#0F172A',
  },
  brand: {
    lightBlueGray: '#F5F7FA',
    coolGray: '#B9BDC8',
    deepNavy: '#0D1118',
    navySurface: '#161B26',
    white: '#FFFFFF',
  },
  red: {
    50: '#FCEEEE',
    500: '#D32F2F',
    600: '#B3261E',
  },
  amber: {
    50: '#FDF3E4',
    500: '#C77700',
  },
  blue: {
    50: '#EFF6FF',
    100: '#DBEAFE',
    200: '#BFDBFE',
    300: '#93C5FD',
    400: '#60A5FA',
    500: '#3B82F6',
    600: '#2563EB',
    700: '#1D4ED8',
    800: '#1E40AF',
    900: '#1E3A8A',
    950: '#172554',
  },
} as const

export type Primitives = typeof primitives
